import React from 'react';
import { motion } from 'framer-motion';
import { FaBookOpen, FaDumbbell, FaMobileAlt, FaChartLine, FaComments } from 'react-icons/fa';

class Features extends React.Component {
  features = [
    {
      icon: <FaBookOpen />,
      title: "Acesso Instantâneo ao eBook",
      text: "Obtenha meu guia comprovado para perda de gordura imediatamente após o cadastro"
    },
    { 
      icon: <FaDumbbell />, 
      title: "Plano Personalizado para Perda de Gordura", 
      text: "Treinos sob medida que se encaixam perfeitamente na sua rotina e nível de experiência" 
    },
    { 
      icon: <FaMobileAlt />, 
      title: "Integração com o App", 
      text: "Seu plano personalizado na palma da sua mão, direto no smartphone." 
    },
    { 
      icon: <FaChartLine />, 
      title: "Acompanhamento de Progresso", 
      text: "Registro semanal de medidas corporais e progresso com fotos" 
    },
    { 
      icon: <FaComments />, 
      title: "Suporte Contínuo pelo Coach", 
      text: "Acesso direto a mim para checagens de forma e suporte contínuo via mensagens no app ou whatsapp" 
    }
  ];

  render() {
    return (
      <section id="features" className="py-16 bg-white">
        <div className="max-w-6xl mx-auto px-4">
          <motion.h2 
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            className="text-3xl font-bold text-center mb-12"
          >
            Seu Kit Completo de Transformação
          </motion.h2>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            {this.features.map((feature, index) => (
              <motion.div 
                key={index}
                initial={{ opacity: 0, y: 50 }}
                whileInView={{ opacity: 1, y: 0 }}
                transition={{ delay: index * 0.15 }}
                viewport={{ once: true }}
                className={`text-center p-6 rounded-xl shadow-lg hover:shadow-xl transition-all ${
                  feature.title === "Suporte Contínuo pelo Coach" 
                    ? "bg-blue-50 border-2 border-blue-200" 
                    : "bg-white"
                }`}
              >
                <div className="text-4xl text-blue-500 mb-4 flex justify-center">
                  {feature.icon}
                </div>
                <h3 className="text-xl font-bold mb-2">{feature.title}</h3>
                <p className="text-gray-600">{feature.text}</p>
                
                {feature.title === "Suporte Contínuo pelo Coach" && (
                  <div className="mt-4">
                    <span className="inline-block bg-blue-100 text-blue-600 px-3 py-1 rounded-full text-sm font-semibold">
                      Progresso com Suporte do Coach
                    </span>
                  </div>
                )}
              </motion.div>
            ))}
          </div>

          {/* Conector Visual para Grade de Números Ímpares */}
          <div className="mt-8 flex justify-center">
            <div className="h-1 w-32 bg-blue-100 rounded-full" />
          </div>
        </div>
      </section>
    );
  }
}

export default Features;
